import { useState } from "react";
import { faqs } from "@/mocks/guage";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 text-accent-700 text-xs md:text-sm font-medium">
              <span className="w-6 h-px bg-accent-500"></span>
              你想问的
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl text-foreground-950">常见问题</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              关于内容口径、弹幕来源和更新节奏，瓜哥在这里一次性说清楚。还有疑问可以直接发邮件过来。
            </p>
            <a
              href="#contact"
              className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-foreground-950 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              <i className="ri-question-answer-line"></i>
              还有别的问题
            </a>
          </div>

          <div className="lg:col-span-8 space-y-3">
            {faqs.map((faq, index) => {
              const isOpen = open === index;
              return (
                <div
                  key={faq.q}
                  className={`rounded-lg border transition-colors ${
                    isOpen ? "bg-background-50 border-primary-300" : "bg-background-50 border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-5 text-left cursor-pointer"
                  >
                    <span className="flex items-start gap-3">
                      <span className="font-heading text-primary-500 shrink-0">Q{index + 1}</span>
                      <span className="text-sm md:text-base font-medium text-foreground-950">{faq.q}</span>
                    </span>
                    <i
                      className={`shrink-0 text-lg text-foreground-500 transition-transform ${
                        isOpen ? "ri-subtract-line text-primary-600" : "ri-add-line"
                      }`}
                    ></i>
                  </button>
                  {isOpen && (
                    <div className="px-5 md:px-6 pb-5">
                      <p className="text-sm md:text-base text-foreground-600 leading-loose pl-8">
                        {faq.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}